import { useQuery } from '@tanstack/react-query';
import { requestCCApi } from 'src/utils';
import { queryKeys } from 'src/utils/queryKeys';

import { mapAllDayparts } from './helpers';

export const useGetAllDayparts = () =>
  useQuery({
    queryKey: queryKeys.dayparts.all(),
    queryFn: fetchAllDayparts,
  });

export const fetchAllDayparts = async () => {
  const response = await requestCCApi({
    url: '/dayparts?pageSize=0&sort=default_start_time',
  });

  if (response.data) {
    return mapAllDayparts(response.data);
  }

  return [];
};
